import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "h-full p-4 rounded",
  "data-testid": "event-sidebar"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "mb-2 text-xl" }, "Event comments", -1)
const _hoisted_5 = { class: "mb-2 text-xl" }
const _hoisted_6 = { class: "text-xs text-gray-500" }
const _hoisted_7 = { class: "mb-2 text-xs text-gray-500" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "mb-2" }, "Comments", -1)
const _hoisted_9 = { class: "pb-12 h-2/3" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Update")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_component = _resolveComponent("icon-component")
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.event.name), 1),
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.formatDate(_ctx.event.date)), 1),
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.event.title), 1)
      ]),
      _createVNode(_component_icon_component, {
        class: "w-10 h-10 ml-auto",
        icon: _ctx.GradeIconMap.get(_ctx.event.overallGrade)
      }, null, 8, ["icon"])
    ]),
    _hoisted_8,
    _createVNode("div", _hoisted_9, [
      _withDirectives(_createVNode("textarea", {
        class: "flex w-full h-full p-2 mb-4 text-sm border rounded resize-none",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.comments = $event)),
        "data-testid": "event-overall-comments"
      }, null, 512), [
        [_vModelText, _ctx.comments]
      ]),
      _createVNode("span", {
        class: ["float-right text-sm", {
          'text-red-600': _ctx.comments.length > _ctx.commentMaxLength
        }]
      }, _toDisplayString(_ctx.comments.length) + " / " + _toDisplayString(_ctx.commentMaxLength), 3)
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode("span", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args))),
        class: "pr-4 ml-auto text-sm cursor-pointer",
        "data-testid": "event-close-button"
      }, "Close"),
      _createVNode(_component_button_component, {
        onClick: _ctx.handleCommentsSelected,
        "data-testid": "event-update-button"
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}